import React, { useState, useEffect } from 'react';
import styled, { keyframes } from 'styled-components';

// XP Shutdown overlay — "Windows is shutting down..." then fade to black
function ShutdownScreen({ onComplete }) {
    const [phase, setPhase] = useState('message'); // 'message' | 'black'

    useEffect(() => {
        const blackTimer = setTimeout(() => setPhase('black'), 3000);
        const completeTimer = setTimeout(() => {
            if (onComplete) onComplete();
        }, 4500);
        return () => {
            clearTimeout(blackTimer);
            clearTimeout(completeTimer);
        };
    }, [onComplete]);

    return (
        <Overlay>
            {phase === 'message' && (
                <MessageScreen>
                    <ShutdownText>Windows is shutting down...</ShutdownText>
                    <ProgressContainer>
                        <ProgressBar />
                    </ProgressContainer>
                </MessageScreen>
            )}
            {phase === 'black' && <BlackScreen />}
        </Overlay>
    );
}

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const slideProgress = keyframes`
  0% { width: 0%; }
  100% { width: 100%; }
`;

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 999998;
`;

const MessageScreen = styled.div`
  width: 100%;
  height: 100%;
  background: linear-gradient(180deg, #1a47a0 0%, #0d3080 40%, #092468 100%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  animation: ${fadeIn} 0.5s ease;
`;

const ShutdownText = styled.div`
  color: #fff;
  font-family: 'Segoe UI', 'Franklin Gothic Medium', Tahoma, sans-serif;
  font-size: 22px;
  font-weight: 300;
  letter-spacing: 1px;
  margin-bottom: 24px;
`;

const ProgressContainer = styled.div`
  width: 200px;
  height: 16px;
  border: 1px solid rgba(255,255,255,0.3);
  border-radius: 8px;
  overflow: hidden;
  background: rgba(0,0,0,0.3);
  padding: 2px;
`;

const ProgressBar = styled.div`
  height: 100%;
  background: linear-gradient(180deg, #5599ff 0%, #2266cc 50%, #1144aa 100%);
  border-radius: 6px;
  animation: ${slideProgress} 2.8s ease-in-out forwards;
`;

const BlackScreen = styled.div`
  width: 100%;
  height: 100%;
  background: #000;
  animation: ${fadeIn} 1s ease;
`;

export default ShutdownScreen;
